module.exports = {
  HBL: 'Số phân đơn nhập khẩu',
  SONO: 'SONO (giữ nguyên thuật ngữ)',
  UserDefinedField1: 'Trường tùy chỉnh 1',
  UserDefinedField2: 'Trường tùy chỉnh 2',
  UserDefinedField3: 'Trường tùy chỉnh 3',
  UserDefinedField4: 'Trường tùy chỉnh 4',
  accordingToBusiness: 'Theo nghiệp vụ',
  accordingToCharge: 'Theo chi phí',
  accountStatementNo: 'Số đối chiếu',
  accrued: 'Đã trích lập',
  addCharge: 'Thêm chi phí',
  adjustedOrNot: 'Có điều chỉnh không',
  advanceMoneyOrNot: 'Có ứng hộ không',
  airExport: 'Xuất khẩu hàng không',
  airImport: 'Nhập khẩu hàng không',
  all: 'Tất cả',
  amount: 'Số tiền',
  amountNotWrittenOff: 'Số tiền chưa thanh toán',
  amountRange: 'Khoảng số tiền',
  applicant: 'Người đề nghị',
  applicationNo: 'Số đơn đề nghị',
  applicationStatus: 'Trạng thái đề nghị',
  appliedForPaymentOrNot: 'Đã đề nghị thanh toán chưa',
  approval: 'Phê duyệt đã thông qua',
  auditor: 'Người kiểm duyệt',
  awaitBusinessApproval: 'Chờ phê duyệt nghiệp vụ',
  awaitFinancialApproval: 'Chờ phê duyệt tài chính',
  NosubmitWeaver: 'Chờ gửi lên nền tảng đám mây',
  WeaverApproving: 'Đang phê duyệt trên nền tảng đám mây',
  WeaverApproved: 'Phê duyệt trên nền tảng đám mây đã thông qua',
  back: 'Bước trước',
  bankAccount: 'Số tài khoản ngân hàng',
  bankOfDeposit: 'Ngân hàng mở tài khoản',
  billNo: 'Số hóa đơn',
  billPaymentNo: 'Số đơn đề nghị thanh toán',
  bookingNo: 'Mã đặt chỗ',
  businessApproval: 'Phê duyệt nghiệp vụ',
  officeApproval: 'Phê duyệt thương mại',
  businessCreateDate: 'Ngày tạo nghiệp vụ',
  businessDate: 'Ngày nghiệp vụ',
  businessNumber: 'Mã nghiệp vụ',
  businessReferenceNumber: 'Số tham chiếu nghiệp vụ',
  businessStatus: 'Trạng thái nghiệp vụ',
  businessType: 'Loại nghiệp vụ',
  bySettlementAgent: 'Thông qua đại lý thanh toán',
  cancel: 'Hủy',
  cancelPartialWriteOff: 'Hủy thanh toán một phần',
  carrier: 'Hãng vận chuyển',
  carrierId: 'Hãng vận chuyển',
  chargeItem: 'Tên chi phí',
  chargeOriginalAmount: 'Số tiền gốc của chi phí',
  chargeOriginalCurrency: 'Loại tiền gốc của chi phí',
  chargeOriginalExchangeRate: 'Tỷ giá gốc của chi phí',
  chargeRemark: 'Ghi chú chi phí',
  collectInvoice: 'Nhận hóa đơn',
  confirmDate: 'Ngày xác nhận',
  confirmRemarks: 'Ghi chú xác nhận',
  confirmUser: 'Người xác nhận chi phí',
  confirmationStatus: 'Trạng thái xác nhận',
  consignationCompany: 'Đơn vị ủy thác',
  contactPerson: 'Người liên hệ',
  containerNo: 'Số container',
  containerSizeAmount: 'Loại container/Khối lượng container',
  controlledOrNot: 'Có kiểm soát hay không',
  couldNotSearhWriteOffJobFromThisWindow: 'Lưu ý: Giao diện này đã lọc bỏ các chi phí/dịch vụ đã được thanh toán hoàn toàn',
  creator: 'Người tạo',
  currency: 'Loại tiền tệ',
  customJobType: 'Loại dịch vụ tùy chỉnh',
  customer: 'Khách hàng',
  customerContact: 'Người liên hệ nghiệp vụ',
  customerService: 'Dịch vụ khách hàng',
  dateOfApplication: 'Ngày yêu cầu',
  dateOfCreation: 'Ngày tạo',
  delete: 'Xóa',
  department: 'Phòng ban',
  departmentApproval: 'Phê duyệt phòng ban',
  destinationAgent: 'Đại lý cảng đến',
  domesticInternational: 'Trong nước/Nước ngoài',
  edit: 'Sửa đổi',
  edit2: 'Chỉnh sửa',
  eta: 'Thời gian dự kiến đến',
  etd: 'Thời gian dự kiến khởi hành',
  atd: 'Thời gian thực tế khởi hành',
  ata: 'Thời gian thực tế đến',
  exchangeRate: 'Tỷ giá',
  export: 'Xuất khẩu',
  exportExcel: 'Xuất Excel',
  exportPDF: 'Xuất PDF',
  feeStatus: 'Trạng thái chi phí',
  financialApproval: 'Phê duyệt tài chính',
  financialAudit: 'Kiểm tra tài chính',
  financialDate: 'Ngày tài chính',
  generatedBillsOrNot: 'Đã tạo hóa đơn hay chưa',
  import: 'Nhập khẩu',
  importhbl: 'Số phân đơn nhập khẩu',
  includeReceivables: 'Bao gồm phải thu',
  inputBy: 'Người tạo chi phí',
  inquiryWay: 'Phương thức truy vấn',
  invalid: 'Hủy bỏ',
  invoiceDate: 'Ngày lập hóa đơn phải thu',
  invoiceDateAll: 'Ngày lập hóa đơn',
  invoiceHeader: 'Tên người nhận hóa đơn',
  sellerInvoiceTitle: 'Seller invoice title',
  dateModified: 'Thời gian thay đổi',
  modifiedBy: 'Người thay đổi',
  invoiceNo: 'Số hóa đơn',
  invoiceState: 'Trạng thái hóa đơn phải thu',
  invoicedOrNot: 'Đã lập hóa đơn chưa',
  invoicingMethod: 'Phương thức lập hóa đơn',
  isNeedInvoice: 'Có cần lập hóa đơn không',
  isReceivable: 'Loại thu chi',
  itemNo: 'Mã dự án',
  lclMasterOrNot: 'Có phải là phiếu nhỏ không',
  masterFlagOrNot: 'Có phải là phiếu chính không',
  mbl: 'Số phiếu chính',
  methodOfPayment: 'Phương thức thanh toán',
  monetaryEquivalent: 'Số tiền quy đổi',
  needInvoice: 'Có cần lập hóa đơn không',
  new: 'Thêm mới',
  newActualPayment: 'Thêm thanh toán thực tế',
  newActualReceipt: 'Thêm thu thực tế',
  newPaymentRequest: 'Tạo yêu cầu thanh toán',
  changePaymentRequest: 'Sửa yêu cầu thanh toán',
  deletePaymentRequest: 'Xóa yêu cầu',
  submintPaymentRequest: 'Gửi yêu cầu',
  next: 'Bước tiếp theo',
  notSubmitted: 'Chưa gửi',
  oceanExport: 'Xuất khẩu đường biển',
  oceanImport: 'Nhập khẩu đường biển',
  operation: 'Thao tác',
  originalAmount: 'Số tiền gốc',
  payReceiveDate: 'Ngày thu/chi',
  payables: 'Phải trả',
  payment: 'Thanh toán',
  paymentDate: 'Ngày thanh toán',
  paymentPeriod: 'Thời hạn thanh toán',
  paymentPeriodUnit: 'Đơn vị thời hạn thanh toán',
  paymentType: 'Loại thanh toán',
  planner: 'Người phụ trách tuyến đường',
  portOfDestination: 'Cảng đích',
  portOfDestinationAirport: 'Cảng đích (cảng hàng không)',
  portOfDestinationSeaport: 'Cảng đích (cảng biển)',
  portOfDischargeAirport: 'Cảng dỡ hàng (cảng hàng không)',
  portOfDischargeSeaport: 'Cảng dỡ hàng (cảng biển)',
  portOfLoading: 'Cảng đi',
  portOfLoadingAirport: 'Cảng đi (cảng hàng không)',
  portOfLoadingSeaport: 'Cảng đi (cảng biển)',
  portOfTransfer: 'Cảng trung chuyển',
  print: 'In',
  quantity: 'Số lượng',
  query: 'Tìm kiếm',
  receipt: 'Thu tiền',
  receiptDate: 'Ngày thu tiền',
  receivables: 'Phải thu',
  receivablesWriteOfStatus: 'Trạng thái thanh toán phải thu',
  relatedJob: 'Số liên kết giao dịch',
  remarks: 'Ghi chú',
  purpose: 'Mục đích sử dụng',
  postscript: 'Lời nhắn giao dịch',
  preRemarks: 'Ghi chú thu/chi trước',
  ticketNo: 'Số hóa đơn',
  workflowNo: 'Mã quy trình',
  removeCharge: 'Loại bỏ chi phí',
  return: 'Hoàn trả',
  sales: 'Bán hàng',
  save: 'Lưu',
  saveAndAdd: 'Lưu và thêm mới',
  separateNumber: 'Số đơn hàng phụ',
  settleAccountsTo: 'Đối tượng thanh toán',
  settlementAgent: 'Đại lý thanh toán',
  settlementCompany: 'Đơn vị thanh toán',
  customerChineseName: 'Tên tiếng Trung đơn vị ủy thác',
  settlementType: 'Loại thanh toán',
  solicitationType: 'Loại nhận hàng',
  status: 'Trạng thái',
  submit: 'Gửi',
  taxAmount: 'Tiền thuế',
  taxExcludedPrice: 'Giá chưa thuế',
  taxIncludedPrice: 'Giá bao gồm thuế',
  taxRate: 'Thuế suất',
  theAmountOfWriteOffs: 'Số tiền thanh toán',
  currencyAmountOfWriteOffs: 'Tổng số tiền thanh toán theo loại tiền',
  total: 'Tổng cộng',
  totalCurrency: 'Tổng theo loại tiền',
  totalWriteOffs: 'Tổng thanh toán',
  trustFromJob: 'Số liên kết ủy thác',
  uncheck: 'Bỏ chọn',
  unit: 'Đơn vị',
  unitPrice: 'Đơn giá',
  unpaid: 'Chưa thanh toán',
  vessel: 'Tên tàu',
  vesselAndVoyage: 'Tên tàu và chuyến',
  viewDetails: 'Xem chi tiết',
  viewWriteOffList: 'Xem chi tiết thanh toán',
  voyage: 'Chuyến',
  warehouseNo: 'Số nhập kho',
  writeOffCurrency: 'Loại tiền thanh toán',
  writeOffDate: 'Ngày thanh toán',
  writeOffExchangeRate: 'Tỷ giá thanh toán',
  writeOffList: 'Chi tiết thanh toán',
  writeOffSerialNumber: 'Số giao dịch thanh toán',
  wroteOffOrNot: 'Đã thanh toán chưa',
  approveHistoryNode: 'Nút phê duyệt',
  invoice_voucherDate: 'Ngày chứng từ 2',
  time: 'Thời gian',
  approveTime: 'Thời gian phê duyệt',
  operator: 'Người thao tác',
  approval_results: 'Kết quả phê duyệt',
  applicationDepartment: 'Bộ phận đề xuất',
  settleDepartmentPrefix: 'Bộ phận thanh toán',
  writeOffStatus: 'Tình trạng thanh toán',
  moneyWriteOffStatus: 'Tình trạng thanh toán chi phí',
  sendWeaver: 'Gửi lên nền tảng đám mây',
  receivablesAndPayables: 'Phải thu phải trả',
  operationDate: 'Ngày thao tác',
  newPaymentRequest_SR: 'Tạo yêu cầu thanh toán',
  deletePaymentRequest_SR: 'Xóa yêu cầu',
  sendWeaver_SR: 'Gửi lên nền tảng đám mây',
  viewDetails_SR: 'Xem',
  lastInvoicingDate: 'Ngày xuất hóa đơn muộn nhất',
  paymentRequestState: 'Trạng thái yêu cầu thanh toán',
  Cargo_ApplicantPassTips: 'Có đồng ý với yêu cầu thanh toán này không?',
  Cargo_ApplicantReturnToSubmitterTips: 'Yêu cầu này sẽ được trả lại người gửi, xác nhận trả lại?',
  Cargo_ApplicantReturnToBusinessTips: 'Yêu cầu này sẽ được trả lại người phê duyệt nghiệp vụ, xác nhận trả lại?',
  Cargo_ApplicantReturnToFinancialTips: 'Yêu cầu này sẽ được trả lại người phê duyệt tài chính, xác nhận trả lại?',
  approveReason: 'Vui lòng nhập lý do đồng ý',
  returnReason: 'Vui lòng nhập lý do trả lại',
  bdApproveState: 'Trạng thái phê duyệt nghiệp vụ',
  ccApproveState: 'Trạng thái phê duyệt tài chính',
  finApproveState: 'Trạng thái phê duyệt cuối cùng',
  receiptPaymentNo: 'Số chứng từ thu/chi'
}
